import { IconType } from "./icons.types";

export const EditIcon = ({ className, color = "#202224" }: IconType) => {
  return (
    <svg
      width="15"
      height="16"
      viewBox="0 0 15 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <g opacity="0.6">
        <path
          d="M13.75 8V11.75C13.75 13.1307 12.6307 14.25 11.25 14.25H3.75C2.36929 14.25 1.25 13.1307 1.25 11.75V4.25C1.25 2.86929 2.36929 1.75 3.75 1.75H7.5M9.80398 3.01422C9.80398 3.01422 9.80398 3.90815 10.6979 4.80209C11.5918 5.69602 12.4858 5.69603 12.4858 5.69603M5.72167 10.4935L7.59894 10.2253C7.86972 10.1866 8.12066 10.0611 8.31408 9.86772L13.3797 4.80209C13.8734 4.30838 13.8734 3.50792 13.3797 3.01422L12.4858 2.12028C11.9921 1.62657 11.1916 1.62657 10.6979 2.12028L5.63228 7.18592C5.43886 7.37934 5.31339 7.63028 5.2747 7.90106L5.00652 9.77833C4.94693 10.1955 5.3045 10.5531 5.72167 10.4935Z"
          stroke={color}
          strokeLinecap="round"
        />
      </g>
    </svg>
  );
};
